export default __webpack_public_path__ + "static/media/posDevice.b1af684d.png";